<script setup lang="ts">
import { toRef } from 'vue';
import Card from 'primevue/card';
import ToggleSwitch from 'primevue/toggleswitch';
import { FormModel } from '@/models';

const props = defineProps({
  form: {
    type: FormModel,
    required: true
  }
});
const formRef = toRef(props.form);
</script>

<template>
  <div class="row-root">
    <Card>
      <template #content>
        <div class="card-root">
          <div class="form-title">{{ form.title }}</div>
          <div class="options">
            <div class="option">
              <FontAwesomeIcon :icon="['fas', 'user-police']" class="icon" />
              <div class="text">Enforce Order</div>
              <ToggleSwitch v-model="formRef.enforcements.enforceOrder" />
            </div>
            <div class="option">
              <FontAwesomeIcon :icon="['far', 'rotate-exclamation']"
                class="icon"/>
              <div class="text">Allow only once per case</div>
              <ToggleSwitch v-model="formRef.enforcements.onlyOnce" />
            </div>
            <div class="option">
              <FontAwesomeIcon :icon="['fas', 'eye-slash']" class="icon" />
              <div class="text">Hide from data entry</div>
              <ToggleSwitch v-model="formRef.enforcements.hidden" />
            </div>
            <div class="option">
              <FontAwesomeIcon :icon="['far', 'file-lock']" class="icon" />
              <div class="text">Close data entry</div>
              <ToggleSwitch v-model="formRef.enforcements.closeEntry" />
            </div>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<style scoped lang="scss">
:deep(.p-card) {
  cursor: grab;
  border-radius: 4px;
  box-shadow: 0 0 0 1px #ebeff2, 0 1px 10px 1px rgba(15, 15, 15, 0.05),
    0 1px 3px 1px rgba(15, 15, 15, 0.05);
}
.card-root {
  display: flex;
}
.form-title {
  flex: 0.8;
  font-weight: 600;
}
.options {
  display: flex;
  flex-wrap: wrap;
  flex: 1.2;
  column-gap: 30px;
  row-gap: 14px;
}
.option {
  display: flex;
  align-items: center;
  width: 300px;

  .icon {
    margin-right: 12px;
    font-size: 16px;
  }

  .text {
    flex: 1;
    margin-right: 12px;
    font-weight: 600;
  }
}
</style>
